export const en = {
  // Common (shared across views)
  'common.playbackSpeed': 'Playback speed',

  // Navigation
  'nav.review': 'Review',
  'nav.library': 'Library',
  'nav.stats': 'Stats',
  'nav.settings': 'Settings',
  'nav.appTitleSuffix': 'Vocabulary Flashcards',
  'nav.openMenu': 'Open menu',
  'nav.closeMenu': 'Close menu',
  'nav.mainNav': 'Main navigation',
  'nav.reviewSession': 'Review Session',
  'nav.cardLibrary': 'Card Library',
  'nav.media': 'Videos',
  'nav.statistics': 'Statistics',

  // Create-mode segmented control (top of Generate / Document / Media views)
  'nav.create.label': 'Create',
  'nav.create.text': 'Text',
  'nav.create.doc': 'Document',
  'nav.create.media': 'Video / Audio',

  // Generate view
  'generate.takePhoto': 'Take Photo',
  'generate.changePhoto': 'Change Photo',
  'generate.chooseGallery': 'Gallery',
  'generate.clearText': 'Clear text',
  'generate.button': 'Generate Cards',
  'generate.buttonPhoto': 'Generate from Photo',
  'generate.buttonText': 'Generate from Text',
  'generate.buttonBoth': 'Generate from Photo + Text',
  'generate.buttonLoading': 'Generating...',
  'generate.minInput': 'Add a photo or text to start',
  'generate.convertingHeic': 'Converting HEIC...',
  'generate.compressing': 'Compressing...',
  'generate.retry': 'Retry',
  'generate.removeImage': 'Remove image',
  'generate.cardTextInput': 'Card text input',
  'generate.preview': 'Preview',

  // Generate errors
  'generate.error.invalidImage': 'Please upload an image (JPEG, PNG, GIF, WebP, or HEIC)',
  'generate.error.imageTooLarge': 'Image must be less than {{maxSize}}',
  'generate.error.compressionFailed': 'Image is still too large after compression. Try a smaller photo.',
  'generate.error.heicFailed': 'Failed to process image',
  'generate.error.generateFailed': 'Failed to generate cards',

  // Generate — PAYG balance / top-up
  'generate.cap.body': "Your balance is empty ({{balance}} energy). Top up to keep generating.",
  'generate.cap.upgrade': 'Top up',

  // Generate — energy badge + first-session banner (balance visibility)
  'generate.energyBadge.label': 'Energy balance: {{balance}}',
  'generate.energyBadge.zero': 'Out of energy',
  'generate.firstCard.body': 'You have {{balance}} energy — enough for your first cards. Type a word below to try it →',
  'generate.firstCard.dismiss': 'Dismiss',

  // Generate — first-run sample-word chips (issue #7)
  'generate.sampleWords.label': 'Try one of these:',

  // Generate — AI image discovery toggle (promotes the paid per-card feature)
  'generate.aiImageToggle': 'AI image',
  'generate.aiImageHint': 'Add an AI image to cards you keep ({{cost}}/card)',
  // Some auto-fired images couldn't land (energy/tier) — manual per-card CTA remains.
  'generate.aiImageAutoSkip': 'Some AI images could not be added — tap the image button on each card to retry.',

  // Library view
  'library.loading': 'Loading library...',
  'library.retry': 'Retry',
  'library.noCards': 'No cards yet!',
  'library.noCardsHint': 'Generate some flashcards to build your library.',
  'library.emptyExtensionHint': 'Tip: select any word while watching YouTube and save it with the Piccard extension.', 'library.emptyCta': 'Create your first card',
  'library.dismiss': 'Dismiss',
  'library.deleteTitle': 'Delete Card?',
  'library.deleteConfirm': 'This action cannot be undone. Are you sure?',
  'library.cancel': 'Cancel',
  'library.deleting': 'Deleting...',
  'library.delete': 'Delete',
  'library.filterAll': 'All',
  'library.filterLearning': 'Learning',
  'library.filterMastered': 'Mastered',
  'library.card_one': '{{count}} card',
  'library.card_other': '{{count}} cards',
  'library.match_one': '{{count}} match',
  'library.match_other': '{{count}} matches',
  'library.noCardsMatch': 'No cards match "{{query}}"',
  'library.prevPage': 'Previous page',
  'library.nextPage': 'Next page',
  'library.searchImagesFor': 'Search images for {{word}}',
  'library.unmaster': 'Un-master {{word}}',
  'library.markMastered': 'Mark {{word}} as mastered',
  'library.searchPlaceholder': 'Search {{filter}}cards...',
  'library.drag': 'DRAG',
  'library.swipeHint': '← Delete · View →',
  'library.back': 'Back',
  'library.images': 'Images',
  'library.master': 'Master',
  'library.mastered': 'Mastered',
  'library.view': 'View',
  'library.fromMedia': 'From media',
  'library.fromDoc': 'From doc',

  // Review view
  'review.ready': 'Ready to Review?',
  'review.readyHint': 'Pick a topic or start with all due cards',
  'review.recognition': 'Recognition',
  'review.production': 'Production',
  'review.topics': 'Topics',
  'review.domains': 'Domains',
  'review.startReview': 'Start Review',
  'review.loading': 'Loading cards...',
  'review.retry': 'Retry',
  'review.tapFlip': 'Tap to flip',
  'review.answer': 'Answer',
  'review.newWord': 'New Word',
  'review.cardProgress': 'Card {{current}} of {{total}}',
  'review.searchImagesFor': 'Search images for {{word}}',
  'review.allCaughtUp': 'All caught up!',
  'review.nothingToReview': 'Nothing to review right now.',
  'review.makeSomeCards': 'Make some cards',
  'review.makeMoreCards': 'Make more "{{topic}}" cards',
  'review.backToReview': 'Back to review',
  'review.noMatchTitle': 'No cards matched "{{topic}}"',
  'review.noMatchHint': "Including cards that partially match your topic",
  'review.fallbackTitle': "No cards matched \"{{topic}}\" — here's everything due",
  'review.sessionComplete': 'Session Complete!',
  'review.cardsReviewed': 'Cards Reviewed',
  'review.again': 'Again',
  'review.hard': 'Hard',
  'review.good': 'Good',
  'review.easy': 'Easy',
  'review.timeSpent': 'Time Spent',
  'review.cardReviewed_one': '{{count}} card reviewed today',
  'review.cardReviewed_other': '{{count}} cards reviewed today',
  'review.startNewSession': 'Start New Session',

  // Share check-in card (issue #1 — /s/:slug poster pages)
  'share.cta': 'Share check-in card',
  'share.title': 'Share your progress',
  'share.name': 'Display name',
  'share.create': 'Create share link',
  'share.copied': 'Link copied!',
  'share.open': 'Open share page',
  'share.saveImage': 'Save poster image',
  'share.myLinks': 'My shared links',
  'share.revoke': 'Revoke',
  'share.empty': 'No shared links yet — finish a review session to share your streak.',
  'review.tapOrSpace': 'Tap card or press Space to flip',
  'review.images': 'Images',
  'review.prefillMore': 'more words and expressions about {{topic}}',
  'review.endSession': 'End Session',
  'review.error.loadFailed': 'Failed to load cards',
  'review.error.submitFailed': 'Failed to submit review',

  // Stats view
  'stats.today': 'Today',
  'stats.reviewedToday': 'reviewed today',
  'stats.review_one': 'review',
  'stats.review_other': 'reviews',
  'stats.mastered': 'mastered',
  'stats.learned': 'words learned',
  'stats.word_one': 'word',
  'stats.word_other': 'words',
  'stats.error': 'Failed to load stats',
  'stats.dailyGoal': 'Daily goal',
  'stats.goalFresh': 'A fresh start.',
  'stats.goalGoing': 'Keep going.',
  'stats.goalMet': 'Goal met — nice work.',
  'stats.goalHint': 'Tap to set your pace',

  // Settings view
  'settings.title': 'Settings',
  'settings.languagePair': 'Language Pair',
  'settings.learn': 'Learn',
  'settings.pairOption': '{{native}} → Learn {{target}}',
  'settings.pairGroup': '{{langA}} ↔ {{langB}}',
  'settings.cardsPerSession': 'Cards per session',
  'settings.cardLabel': '{{count}} cards',
  'settings.changeWarning': 'Changing language will reload the app',
  'settings.apply': 'Apply',
  'settings.cancelChange': 'Cancel',

  // Settings — learning context (free-text goal that tunes AI generation)
  'settings.learningContext.label': 'Learning goal',
  'settings.learningContext.optional': 'optional',
  'settings.learningContext.placeholder': 'e.g. GRE vocab, HSK prep, business English…',
  'settings.learningContext.hint': 'Shapes which words the AI picks. Skip to accept defaults.',
  'settings.learningContext.try': 'Try:',
  'settings.learningContext.example1': 'HSK prep',
  'settings.learningContext.example2': 'Business English',
  'settings.learningContext.example3': 'Daily conversation',
  'settings.learningContext.example4': 'Australian slang',

  // Settings — PAYG balance
  'settings.plan.balanceTitle': 'Energy balance',
  'settings.plan.balanceDesc': '{{balance}} energy available',
  'settings.plan.topup': 'Top up ${{amount}}',
  'settings.plan.energyUnit': '{{energy}} energy',
  'settings.plan.bonusPct': '+{{percent}}% bonus',
  'settings.plan.bestValue': 'Best value',
  'settings.support.title': 'Need help?',
  'settings.support.desc': 'Questions, billing, or feedback — email us anytime.',

  // Referral (two-sided give-get, PAYG: 150/150 energy, fires on invitee first top-up. ADR 0005)
  'settings.referral.title': 'Invite friends, you both get 150 energy',
  'settings.referral.desc': 'Share your link. When a friend tops up, you each get 150 energy free.',
  'settings.referral.yourCode': 'Your invite code',
  'settings.referral.copyCode': 'Copy invite code',
  'settings.referral.tapToCopy': 'Tap to copy',
  'settings.referral.codeCopied': 'Copied',
  'settings.referral.shareLink': 'Share link',
  'settings.referral.invited_one': '{{count}} friend invited',
  'settings.referral.invited_other': '{{count}} friends invited',
  'settings.referral.toppedUp_one': '{{count}} topped up',
  'settings.referral.toppedUp_other': '{{count}} topped up',
  'settings.referral.pendingHint': "Waiting for their first top-up — nudge them!",
  'settings.referral.shareText': 'Learning vocab from photos of my life. We both get 150 energy when you top up — try Piccard:',
  'settings.referral.rewardBanner': 'Your friend topped up — 150 energy added to your balance.',
  'settings.referral.rewardDismiss': 'Got it',
  'settings.referral.haveCode': 'Have a referral code?',
  'settings.referral.codePlaceholder': 'Enter code',
  'settings.referral.codeApply': 'Apply',
  'settings.referral.codeApplying': 'Applying…',
  'settings.referral.codeApplied': "Code applied — you and your referrer each get 150 energy when you top up.",
  'settings.referral.codeAlready': 'A referral is already applied to your account.',
  'settings.referral.codeInvalid': "That code isn't valid.",
  'settings.referral.codeSelf': "That's your own code.",

  // Payment (shared)
  'payment.checkoutFailed': "Couldn't start checkout. Try again.",
  'payment.checkoutLoading': 'Opening checkout...',
  'payment.checkoutSuccess': "Top-up received — thanks!",
  'payment.checkoutCancelled': "Checkout cancelled.",

  // Hamburger menu
  'menu.notSignedIn': 'Not signed in',
  'menu.signOut': 'Sign Out',
  'menu.languageLearner': 'Language Learner',

  // Onboarding
  'onboarding.iSpeak': 'I speak…',
  'onboarding.imLearning': "I'm learning…",
  'onboarding.startLearning': 'Start learning',
  'onboarding.changeAnytime': 'You can change this anytime.',
  'onboarding.back': '← Back',
  'onboarding.learningContext.label': 'Studying for anything specific?',
  'onboarding.learningContext.placeholder': 'e.g. GRE, HSK, business English… (optional)',

  // Auth
  'auth.signInPrompt': 'Sign in to save your vocabulary to the cloud',
  'auth.continueWithGoogle': 'Continue with Google',
  'auth.continueWithKakao': 'Continue with Kakao',
  'auth.signingIn': 'Signing in...',
  'auth.signingYouIn': 'Signing you in...',
  'auth.signInFailed': 'Sign in failed',
  'auth.signInError': 'Something went wrong during authentication.',
  'auth.tryAgain': 'Try Again',
  'auth.loading': 'Loading...',

  // Error boundary
  'error.title': 'Something went wrong',
  'error.description': 'An unexpected error occurred.',
  'error.tryAgain': 'Try Again',
  'error.report': 'Report',

  // Offline
  'offline.title': "You're offline",
  'offline.description': 'Some features may be limited. Check your connection.',
  'offline.notification': 'Offline notification',
  'offline.retryConnection': 'Retry connection',

  // PWA install
  'pwa.installPrompt': 'Install Piccard for offline access',
  'pwa.install': 'Install',
  'pwa.dismiss': 'Dismiss',
  'pwa.installAppPrompt': 'Install app prompt',
  'pwa.installApp': 'Install app',

  // Card stack
  'cardStack.cardGenerated': '1 card generated',
  'cardStack.cardGenerated_other': '{{count}} cards generated',
  'cardStack.counter': '{{current}} / {{total}} cards',
  'cardStack.done': 'Done',
  'cardStack.reviewNow': 'Review Now',
  'cardStack.generateMore': 'Generate More',
  'cardStack.allReviewed': 'All cards reviewed',
  'cardStack.cardsSaved': '{{count}} cards saved',
  'cardStack.previousCard': 'Previous card',
  'cardStack.nextCard': 'Next card',
  'cardStack.goToCard': 'Go to card {{n}}',

  // Preview card
  'previewCard.generatedCard': 'Generated Card',
  'previewCard.translation': 'Translation',
  'previewCard.definition': 'Definition',
  'previewCard.example': 'Example',
  'previewCard.searchImagesFor': 'Search images for {{word}}',

  // Rating buttons
  'rating.again': 'Again',
  'rating.hard': 'Hard',
  'rating.good': 'Good',
  'rating.easy': 'Easy',
  'rating.master': 'Master',
  'rating.rateAs': 'Rate as {{label}}',
  'rating.markMastered': 'Mark as mastered',

  // Leech / "stuck" card reframe — shows when a Review card has lapsed too many
  // times. Reframes the failure onto the card, not the learner, and points to
  // the retire (Master) action as the optional suspend.
  'review.stuckHint': "This card's slipped {{count}}× — not your fault, some cards just don't stick. Retire it below, or keep drilling.",

  // Study card
  'studyCard.studyCardFor': 'Study card for: {{word}}',
  'studyCard.playUsPronunciation': 'Play US pronunciation',
  'studyCard.playUkPronunciation': 'Play UK pronunciation',
  'studyCard.searchImagesFor': 'Search images for {{word}}',

  // Pronunciation button + badge
  'pronunciation.play': 'Play {{accent}} pronunciation',

  // Search bar
  'search.clearSearch': 'Clear search',

  // Tag cloud
  'tagCloud.yourTopics': 'Your Topics',
  'tagCloud.showMore': 'Show {{count}} more {{label}}',

  // Queue item
  'queueItem.remove': 'Remove {{word}}',

  // Error card
  'errorCard.defaultRetry': 'Try Again',

  // Empty state
  'emptyState.noCards': 'No cards yet',
  'emptyState.noCardsHint': 'Create your first flashcard to get started',
  'emptyState.createCard': 'Create Card',
  'emptyState.noMastered': 'No mastered words yet.',
  'emptyState.noMasteredHint': 'Mark cards as mastered to see them here.',
  'emptyState.allMastered': 'All your cards are mastered!',
  'emptyState.greatJob': 'Great job!',

  // Progress bar
  'progressBar.cardsLearned': 'Cards Learned',

  // AI image regeneration (shared RegenerateImageButton)
  'common.aiImage': 'AI image',
  'common.aiImagePremium': 'Premium',
  'common.aiImageAria': 'Generate an AI image for {{word}}',
  'common.generating': 'Generating…',
  'common.imageFailed': 'Failed · no energy used',
  'common.lowEnergy': 'Low energy',
  'common.regenerateCard': 'Regenerate',
  'common.regenerateCardAria': 'Completely regenerate {{word}}',

  // Image preview / lightbox
  'imagePreview.enlarge': 'Enlarge image',
  'imagePreview.close': 'Close',

  // Document import view (PDF/TXT → candidate vocab)
  'importView.title': 'Import a document',
  'importView.subtitle': 'Turn a PDF or text into vocabulary cards.',
  'importView.chooseFile': 'Choose PDF or text file',
  'importView.pasteLabel': 'Or paste text',
  'importView.pastePlaceholder': 'Paste your article, notes, or any text…',
  'importView.findVocab': 'Find Vocabulary',
  'importView.proposing': 'Finding vocabulary…',
  'importView.proposingWait': 'Picking words & writing definitions — 10–20s for longer texts.',
  'importView.phaseReading': 'Reading your text…',
  'importView.foundSoFar': 'Found {{n}} · still looking…',
  'importView.cancel': 'Cancel',
  'importView.partialBanner': 'Found {{n}} words, but the analysis stopped early.',
  'importView.retryRest': 'Find the rest',
  'importView.parsing': 'Reading document…',
  'importView.candidates': '{{count}} candidates',
  'importView.keepN': 'Keep {{count}} · {{energy}} energy',
  'importView.generate': 'Generate {{count}} cards',
  'importView.selectAll': 'Select all',
  'importView.clearAll': 'Clear all',
  'importView.priorityHigh': 'High value',
  'importView.highCount': '{{high}} high-value of {{total}}',
  'mediaView.selectRecommended': 'Select recommended',
  'importView.success': '{{count}} cards added to your library',
  'importView.pairMismatch': 'Cards will be saved as {{pair}} — your app is set to {{current}}. Switch in Settings to review them.',
  'importView.savedAs': 'Saved as {{pair}}',
  'importView.reviewInPair': 'Switch to {{pair}} & review',
  'importView.reviewNow': 'Review now',
  'importView.errorTooLarge': 'Document is too large (max ~800K characters).',
  'importView.errorScanned': 'No selectable text found — this looks like a scanned PDF.',
  'importView.errorRead': "Couldn't read this file.",
  'importView.errorPropose': "Couldn't extract vocabulary. Try again.",
  'importView.errorRateLimited': 'Too many requests in a row. Wait about a minute, then try again.',
  'importView.errorLowEnergy': 'Not enough energy to save these cards.',
  'importView.empty': 'No vocabulary found. Try another document.',

  // Quick save view (extension lookup → one-step card)
  'quickSave.title': 'Save to Piccard',
  'quickSave.subtitle': 'One tap and your card is ready to review.',
  'quickSave.generate': 'Generate card',
  'quickSave.generateCost': 'Generate card · {{energy}} energy',
  'quickSave.generating': 'Making your card…',
  'quickSave.slowWait': 'Making your card usually takes a few seconds — hang tight.',
  'quickSave.pairSourceExtension': 'from this video',
  'quickSave.pairSourceSettings': 'your app setting',
  'quickSave.pairSourceBrowser': 'your browser language',
  'quickSave.fromYoutube': 'From this video',
  'quickSave.fromNetflix': 'From this show',
  'quickSave.pairLabel': 'Card language',
  'quickSave.energyHint': 'Generation costs {{energy}} energy · balance {{balance}}',
  'quickSave.errorBalance': 'Not enough energy to generate this card.',
  'quickSave.errorNetwork': "Couldn't generate the card. Try again.",
  'quickSave.topUp': 'Top up',
  'card.fromSource': 'From your document',
  'card.grammar': 'Grammar',
  'card.prosody': 'Stress & rhythm',
  'card.fromClip': 'Clip',
  'card.fromYoutube': 'YouTube',
  'card.openInNetflix': 'Open in Netflix',
  'card.fromNetflix': 'Netflix',
  'card.fromPdf': 'PDF',
  'card.fromPhoto': 'Your photo',
  'card.lookedUp': 'Looked up',
  'card.expand': 'Expand',
  'card.collapse': 'Collapse',

  // Media → cards (video/audio → English transcript → segment-linked cards)
  'mediaView.title': 'Turn a clip into cards',
  'mediaView.subtitle': 'Bring English audio or video. We transcribe it, you pick.',
  'mediaView.chooseFile': 'Drop file or tap to pick',
  'mediaView.formats': 'mp4 · mov · webm · mp3…',
  'mediaView.cap': 'Up to 90 min · up to 100MB',
  'mediaView.guideExtension.body': 'Installed the extension? Select any subtitle word on a YouTube/Netflix video page and tap the Piccard button to save a card. You can also import your own video/audio file below →',
  'mediaView.guideExtension.dismiss': 'Dismiss',
  'mediaView.uploading': 'Uploading…',
  'mediaView.transcribe': 'Transcribe',
  'mediaView.transcribing': 'Transcribing…',
  'mediaView.transcribeHint': 'A short clip takes a few seconds.',
  'mediaView.changeFile': 'Change file',
  'mediaView.costN': '{{energy}} energy',
  'mediaView.phrases': '{{count}} phrases',
  'mediaView.make': 'Make {{count}} cards',
  'mediaView.uncertain': 'Double-check this phrase',
  'mediaView.preview': 'Play this phrase',
  'mediaView.success': '{{count}} cards ready in Review',
  'mediaView.errorUpload': 'Upload failed. Try again.',
  'mediaView.errorTooLarge': 'Over 100MB — trim it shorter for now.',
  'mediaView.errorSilent': 'No audible speech found in this file. It may be a silent video — pick a clip with dialogue.',
  'mediaView.errorFormat': 'Unsupported format. Use mp4, mov, webm, or an audio file.',
  'mediaView.errorTranscribe': 'Transcription service is busy. Retry — you were not charged.',
  'mediaView.tooLongDuration': 'Over {{n}} minutes — trim the clip shorter, then add it again.',
  'mediaView.errorContent': 'No English speech found in this file.',
  'mediaView.errLanguageMismatch': 'This clip doesn\'t sound like {{lang}}. Pick {{lang}} audio or video, or switch your learning language first.',
  'mediaView.errBadFormat': 'This file\'s real format can\'t be transcribed (like .avi or .mkv renamed to .mp4). Convert it to mp4, mov, webm, or a standard audio format.',
  'mediaView.errNoSpeech': 'No speech detected in this file. Pick a clip with clear dialogue.',
  'mediaView.errDecode': 'The audio in this file could not be processed. Try a standard mp4, mov, webm, or audio file.',
  'mediaView.fromFile': 'from {{name}}',
  'mediaView.errorLowEnergy': 'Not enough energy.',
  'mediaView.errorConfirm': "Couldn't build cards from these phrases. Try again.",
  'mediaView.empty': 'No phrases found in this clip.',
  'mediaView.costEstimate': '~{{cost}} energy · ~{{min}} min',
  'mediaView.feeApplied': '({{n}} energy detection fee applied)',
  // Redeem (hidden /app/redeem page — promo/beta/bonus codes)
  'settings.section.energy': 'Energy',
  'settings.section.learning': 'Learning',
  'redeem.title': 'Redeem code',
  'redeem.desc': 'Enter a code to receive energy.',
  'redeem.placeholder': 'Enter code',
  'redeem.apply': 'Redeem',
  'redeem.applying': '…',
  'redeem.success': 'Redeemed! +{{cents}} energy',
  'redeem.already': 'You already redeemed this code',
  'redeem.invalid': 'Invalid or expired code',
  'redeem.error': 'Something went wrong. Try again.',
  'redeem.balance': '{{balance}} energy available',

  // Landing page (v11 — extension-first entry, closed loop. Copy frozen in
  // docs/plans/landing-v11.md; locale from ?lang / ?ref hint / navigator.languages)
  'landing.hero.title': 'Learn vocabulary\nfrom YouTube.',
  'landing.hero.subtitle': 'Bilingual subtitles on the videos you watch: English with Japanese, Korean, Chinese, Spanish, French, or German, both directions. Tap a line, make the cards in one click — meaning, example sentence, pronunciation — and each one returns right before you’d forget it.',
  'landing.hero.cta': 'Get started',
  'landing.hero.ctaNote': 'Free. No credit card needed.',
  'landing.hero.ctaExtension': 'Add to Chrome',
  'landing.hero.videoCaption': 'From the bilingual panel into Piccard — one line becomes several candidate cards.',
  'landing.how.title': 'From YouTube to flashcards',
  'landing.how.subtitle': 'The loop closes itself: what you watch becomes what you review.',
  'landing.how.step1Title': 'Watch with bilingual subtitles',
  'landing.how.step1Desc': 'The Chrome extension overlays your language on the video you’re watching — every line, synced to the second.',
  'landing.how.step2Title': 'Tap a line. Keep the cards.',
  'landing.how.step2Desc': 'One tap sends the line to Piccard. One click makes the cards — meaning, example sentence, pronunciation on each. Keep what’s worth keeping, discard the rest.',
  'landing.how.step3Title': 'Review comes back to you',
  'landing.how.step3Desc': 'FSRS spaced repetition schedules every card to return right before you’d forget it — and each one replays the exact YouTube moment it came from.',
  'landing.how.otherTitle': 'Other ways in',
  'landing.how.other3': 'Double-click a word on the web — an offline definition appears, and Piccard makes the card in one more click.',
  'landing.how.ownLink': 'Already have a word list? Bring it →',

  // landing-v12 P1-2: persona-2 section (OwnMaterial.tsx) — bring your own list
  'landing.bring.title': 'Bring your own list',
  'landing.bring.subtitle': 'The videos are one way in. Most of the words you actually need are already sitting somewhere — a textbook chapter, an exam word list, a lecture recording. Paste it, drop it, or upload it: Piccard proposes the cards, and you keep the ones worth learning.',
  'landing.bring.pasteTitle': 'Paste the text',
  'landing.bring.pasteDesc': 'A textbook page, an article, the word list you already have. Paste it and the proposed cards come back — select all, or keep the ones worth learning. Up to 20 cards per confirm.',
  'landing.bring.pdfTitle': 'Drop a PDF',
  'landing.bring.pdfDesc': 'Course material, exam word lists, reading packets — a PDF runs through the same proposal. Cards laid out, you tick, one confirm.',
  'landing.bring.fileTitle': 'Upload audio or video',
  'landing.bring.fileDesc': 'A lecture or podcast recording in English, up to 90 minutes, gets transcribed — then every phrase carries a 0–100 worth-learning score (your learning goal counts) and the keepers arrive pre-checked. Audio in the language you’re learning — English lectures if English is your target.',
  'landing.bring.cta': 'Open the app',
  'landing.bring.ctaNote': 'Free. No credit card needed.',
  'landing.pricing.title': 'Pay only for what you use',
  'landing.pricing.subtitle': 'Start with free energy. Top up anytime — it never expires.',
  'landing.pricing.starter': 'Starter',
  'landing.pricing.starterPrice': '$0',
  'landing.pricing.starterToBegin': 'to begin',
  'landing.pricing.starterGrant': '150 free energy when you sign up',
  'landing.pricing.starterSwitch': 'Switch languages anytime',
  'landing.pricing.starterSrs': 'Full spaced repetition',
  'landing.pricing.starterDevices': 'Works on any device',
  'landing.pricing.starterSync': 'Cloud sync included',
  'landing.pricing.starterCta': 'Get Started',
  'landing.pricing.topup': 'Top-up packs',
  'landing.pricing.topupRate': '1 energy ≈ 1 text card',
  'landing.pricing.starterAiImage': 'Text cards included; AI image cards are a paid feature',
  'landing.pricing.topupCards': '500 cards for $5',
  'landing.blog.backHome': '← Home',
  'landing.welcome.openApp': 'Open Piccard',
  'landing.faq.heading': 'Frequently Asked Questions',
  'landing.faq.q1': 'Is Piccard really free?',
  'landing.faq.a1': 'Yes! Every new account gets 150 free energy, enough for a few videos, PDFs, or about 150 cards. Top up with energy packs ($5/$10/$20) only when you want more. Energy never expires.',
  'landing.faq.q2': 'How is this different from Language Reactor or Anki?',
  'landing.faq.a2': 'Both are good tools with a gap between them: Language Reactor shows subtitles but saving words means exporting and importing into Anki, and Anki itself takes real setup — you build every card yourself. Piccard closes that gap. Tap a subtitle line and the cards are already made — meaning, example sentence, pronunciation — keep what’s worth keeping, discard the rest, and FSRS-6, the newer scheduler Anki also offers, does the scheduling. And on longer imports, every phrase is scored 0–100 for how much it’s worth learning — one-line reason on hover, your learning goal in the mix — so you’re never left guessing which words deserve your time. No config, no export/import bridge.',
  'landing.faq.q3': 'Will it slow down YouTube or break the subtitles?',
  'landing.faq.a3': 'No. The extension is lightweight — it adds its own subtitle panel over the video and never edits YouTube itself. If you ever want it gone, one click removes everything. It also works without an account.',
  'landing.faq.q5': 'What’s spaced repetition?',
  'landing.faq.a5': 'A scheduling algorithm decides when each card should come back — early while it’s fresh, later as it settles into long-term memory. Piccard runs FSRS-6, the newest generation of the science behind Anki, and your cards come from what you watch and read.',
  'landing.faq.q7': 'What languages does Piccard support?',
  'landing.faq.a7': '한국어 · 繁體中文 · 日本語 came first; Spanish, French, and German followed. Every pair runs both directions — Japanese for English speakers, English for Japanese speakers, and so on. Switch between them anytime.',

  'landing.faq.q8': 'I already have a word list. Can Piccard turn it into cards?',
  'landing.faq.a8': 'Yes — that’s the fastest way in. Paste the text or drop the PDF and Piccard proposes the cards (up to 20 at a time): meaning, example sentence, pronunciation on each. Lecture recordings work too — upload the audio, it’s transcribed, and each phrase is scored 0–100 for how much it’s worth learning.',
  'landing.faq.q9': 'Does it work on Netflix?',
  'landing.faq.a9': 'Yes, for titles with text subtitles — and when the title offers both languages, Piccard shows bilingual subtitles (English + your language) right on the video. Watch with the Piccard panel open, tap any line to make it a card, and the card links back to the exact second on Netflix. A few titles use image-based subtitles that can\'t be read — and DRM means no screenshots or audio clips; the words and the moment are what you keep.',
  'landing.faq.still': 'Still have questions? Email',
  'landing.footer.tagline': 'Flashcards from what you watch',
  'landing.footer.blog': 'Blog',
  'landing.footer.privacy': 'Privacy',
  'landing.footer.terms': 'Terms',
  'landing.footer.contact': 'Contact',
  'landing.footer.rights': 'All rights reserved.',
  'landing.finalCta.title': 'Your first flashcard is one YouTube video away',
  'landing.finalCta.subtitle': 'Watch something. Tap a line. Make the card — it comes back before you forget it.',
  'landing.finalCta.cta': 'Get started for free',
  'landing.finalCta.ctaExtension': 'Add to Chrome',
  'landing.finalCta.note': 'No credit card needed. 150 energy included.',

  // SEO — prerendered HTML shells (docs/plans/multilingual-seo.md M1)
  'seo.title': 'Learn vocabulary from YouTube — Bilingual subtitles | Piccard',
  'seo.description': 'Bilingual subtitles on YouTube. Tap a line, keep the words worth learning as flashcards, and FSRS brings each one back before you forget.',
} as const
